var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgFavoriteFill16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41291 13.3569C8.63186 14.1379 7.36553 14.1379 6.58448 13.3569L1.87868 8.65106C0.707108 7.47948 0.707106 5.57999 1.87868 4.40841L3.13026 3.15683C4.30183 1.98526 6.20133 1.98526 7.3729 3.15683L7.99869 3.78262L8.62448 3.15683C9.79605 1.98526 11.6955 1.98526 12.8671 3.15683L14.1187 4.40841C15.2903 5.57999 15.2903 7.47948 14.1187 8.65106L9.41291 13.3569Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFavoriteFill16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;